
import { JobOffersSearch } from "@/components/jobs/JobOffersSearch";
import { CandidatesViewOptions, SortField, SortOrder, ViewMode } from "@/components/candidates/CandidatesViewOptions";

interface JobsFilterWrapperProps {
  searchTerm: string;
  setSearchTerm: (term: string) => void;
  sortField: SortField;
  setSortField: (field: SortField) => void;
  sortOrder: SortOrder;
  setSortOrder: (order: SortOrder) => void;
  viewMode: ViewMode;
  setViewMode: (mode: ViewMode) => void;
}

export const JobsFilterWrapper = ({
  searchTerm,
  setSearchTerm,
  sortField,
  setSortField,
  sortOrder,
  setSortOrder,
  viewMode,
  setViewMode
}: JobsFilterWrapperProps) => {
  return (
    <div className="w-full mb-6">
      <JobOffersSearch 
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
      />
      
      <div className="mt-4">
        <CandidatesViewOptions
          sortField={sortField}
          setSortField={setSortField}
          sortOrder={sortOrder}
          setSortOrder={setSortOrder}
          viewMode={viewMode}
          setViewMode={setViewMode}
        />
      </div>
    </div>
  );
};
